import { useMemo, useState } from "react";
import { Scale } from "lucide-react";
import { DEVICES, mobileRows } from "../pages/Mobile";
import { VerdictBadge } from "./VerdictBadge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

function DeviceSelect({ value, onChange, testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="w-full sm:w-[280px]"><SelectValue /></SelectTrigger>
      <SelectContent>{DEVICES.map((d) => <SelectItem key={d.id} value={d.id}>{d.label} · {d.ram} Go</SelectItem>)}</SelectContent>
    </Select>
  );
}

function Cell({ r }) {
  return (
    <td className="px-4 py-2">
      <div className="flex flex-wrap items-center gap-2">
        <VerdictBadge verdict={r.ev.verdict} />
        {r.tok > 0 && <span className="font-mono2 text-xs text-muted-foreground">~{r.tok} tok/s</span>}
      </div>
    </td>
  );
}

export function MobileCompare({ data }) {
  const [a, setA] = useState("ip-6");
  const [b, setB] = useState("pad-16");
  const da = DEVICES.find((d) => d.id === a);
  const db = DEVICES.find((d) => d.id === b);
  const { ra, rb } = useMemo(() => ({ ra: mobileRows(data, da), rb: mobileRows(data, db) }), [data, da, db]);
  const byId = Object.fromEntries(rb.map((r) => [r.m.id, r]));
  const fit = (rows) => rows.filter((r) => r.ev.verdict !== "no_go").length;

  return (
    <section className="space-y-3" data-testid="mobile-compare">
      <h2 className="flex items-center gap-2 font-head text-lg font-bold"><Scale className="h-5 w-5 text-primary" /> Comparer deux appareils</h2>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <DeviceSelect value={a} onChange={setA} testid="mobile-compare-select-a" />
        <span className="text-center text-sm text-muted-foreground">vs</span>
        <DeviceSelect value={b} onChange={setB} testid="mobile-compare-select-b" />
      </div>
      <div className="overflow-x-auto rounded-xl border border-[#1E2638] bg-[#0F141C]">
        <table className="w-full text-sm" data-testid="mobile-compare-table">
          <thead className="border-b border-[#1E2638] text-left text-[11px] uppercase tracking-wide text-muted-foreground">
            <tr>
              <th className="px-4 py-2">Modèle</th>
              <th className="px-4 py-2" data-testid="mobile-compare-count-a">{da.label} · {fit(ra)} compatible(s)</th>
              <th className="px-4 py-2" data-testid="mobile-compare-count-b">{db.label} · {fit(rb)} compatible(s)</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#1E2638]/60">
            {ra.map((r) => (
              <tr key={r.m.id} data-testid="mobile-compare-row">
                <td className="px-4 py-2"><span className="font-medium">{r.m.name}</span> <span className="font-mono2 text-xs text-muted-foreground">{r.m.params}B</span></td>
                <Cell r={r} />
                <Cell r={byId[r.m.id]} />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
